import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import axios from "axios";

import { getAuthorizationToken } from "@/auth/tokenStore";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import { getCaseId, getClientId, fetchShakespeareStatus, fetchPageObject } from "../Utils/helper";
import DatesIcon from "../assets/images/dates.svg";
import DetailIcon from "../assets/images/detail.svg";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import Footer from "../Components/common/footer";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import PageDocsTab, { createDocsTab } from "../Components/DocPage/new-tab/page-docs-tab";
import InsuranceModal from "../Components/Insurance/InsuranceModal";
import ConfirmDeleteModal from "../Components/Insurance/ConfirmDeleteModal";
import "../Components/Insurance/InsurancePage.css";
import { fetchInsurances, deleteInsurance } from "../Redux/insurance/insuranceSlice";
import InsuranceSummaryTable from "../Components/Insurance/views/InsuranceSummaryTable";
import InsuranceDetailedView from "../Components/Insurance/views/InsuranceDetailedView";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import addIconGold from "../assets/Add-icon-gold.svg";
import PlaceHolderifNothingAdded from "../Components/components-new-final/placeholder-nothing-added";

// const getPageTitle = (currentPage, insurances) => {
//   if (currentPage === "all") return "All Insurance";
//   if (currentPage === "photo") return "Photos";

//   if (currentPage?.startsWith("client_")) {
//     const clientId = parseInt(currentPage?.replace("client_", ""));
//     const insurance = insurances?.find((ins) => ins?.for_client?.id === clientId);
//     return insurance
//       ? `Client ${insurance?.for_client?.first_name} ${insurance?.for_client?.last_name} Insurance`
//       : "Client Insurance";
//   }

//   if (currentPage?.startsWith("defendant_")) {
//     const defendantId = parseInt(currentPage?.replace("defendant_", ""));
//     return `Defendant ${defendantId} Insurance`;
//   }

//   if (currentPage?.startsWith("other_")) {
//     const otherId = parseInt(currentPage?.replace("other_", ""));
//     return `Other Party ${otherId} Insurance`;
//   }

//   return "Insurance";
// };

// const PageTitle = ({ currentPage, insurances }) => (
//   <div
//     style={{
//       width: "100%",
//       justifyContent: "flex-start",
//       background: "var(--primary)",
//       height: "25px",
//       marginBottom: "5px",
//     }}
//   >
//     <span
//       className="fw-bold text-white"
//       style={{
//         height: "25px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {getPageTitle(currentPage, insurances)}
//     </span>
//   </div>
// );

const PageContent = ({
  currentPage,
  filteredInsurances,
  viewType,
  editModal,
  setEditModal,
  handleEditModalShow,
  billData,
  pageName,
  pageIcon,
}) => {
  if (currentPage === "docs") {
    return (
      <PageDocsTab
        key={`${getClientId()}-${getCaseId()}`}
        pageId={11}
        pageName={pageName}
        pageIcon={pageIcon}
      />
    );
  }
  if (currentPage === "photo") {
    return <PhotoTab pageId={11} pageName={"Insurance"} />;
  }

  if (viewType === "summary") {
    return <InsuranceSummaryTable insurances={filteredInsurances || []} />;
  }

  return (
    <InsuranceDetailedView
      insurances={filteredInsurances || []}
      editModal={editModal}
      setEditModal={setEditModal}
      handleEditModalShow={handleEditModalShow}
      billData={billData}
    />
  );
};

function NewInsurancePage() {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const dispatch = useDispatch();

  // State management
  const [currentPage, setCurrentPage] = useState("all");
  const [viewType, setViewType] = useState("summary");
  const isMediaPage = currentPage === "photo" || currentPage === "docs";
  const activeViewType = isMediaPage ? null : viewType;
  const [editModal, setEditModal] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [activeTav, setActiveTab] = useState("entity");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedInsuranceDeletionId, setSelectedInsuranceDeletionId] = useState(null);
  const [billData, setBillData] = useState({});
  const [addInsurance, setAddInsurance] = useState(false);

  // Redux selectors
  const { data: insurances } = useSelector((state) => state.insurances);
  // const caseID = useSelector((state) => state?.caseData?.current?.id);
  // const clientID = useSelector((state) => state?.client?.current?.id);

  const tokenBearer = getAuthorizationToken();
  const currentCaseId = getCaseId();
  const clientId = getClientId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 11).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  // Extract URL params
  const { pathname } = useLocation();

  const URLParams = useMemo(() => {
    const numbers = pathname.match(/\d+/g);
    return numbers?.map(Number) || [];
  }, [pathname]);

  // Handlers
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const fecthMedicalBill = async () => {
    try {
      const response1 = await axios.get(
        `${origin}/api/settlement-page/lien-information/?case_id=${currentCaseId}&client_id=${clientId}`,
        {
          headers: {
            Authorization: tokenBearer,
          },
        }
      );

      if (response1.status === 200) setBillData(response1?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Data fetching
  useEffect(() => {
    if (currentCaseId && clientId) {
      fetchShakespeareStatus(currentCaseId, 11, dispatch);
      dispatch(fetchInsurances({ client_id: URLParams[0], case_id: URLParams[1] }));
      fecthMedicalBill();
    }
  }, [URLParams, currentCaseId, clientId]);

  const handleInsuranceCreation = () => {
    if (URLParams.length >= 2) {
      dispatch(fetchInsurances({ client_id: URLParams[0], case_id: URLParams[1] }));
    }
  };

  const handleDelete = async () => {
    await dispatch(deleteInsurance({ insurance_id: selectedInsuranceDeletionId }));
    setShowDeleteModal(false);
    setSelectedInsuranceDeletionId(null);
    handleInsuranceCreation();
  };

  const deleteInsuranceHandler = (id) => {
    setModalShow(false);
    setShowDeleteModal(true);
    setSelectedInsuranceDeletionId(id);
  };

  const handleEditModalShow = (tab) => {
    setActiveTab(tab);
    setModalShow(true);
  };

  const addInsuranceModalShow = () => {
    setAddInsurance(true);
    setEditModal({});
    setModalShow(true);
  };

  const handleInsuranceModalClose = () => {
    setAddInsurance(false);
    setEditModal({});
    setModalShow(false);
  };

  // Filter insurances based on current page
  const filteredInsurances = useMemo(() => {
    if (!insurances) return [];

    if (currentPage === "all" || currentPage === "photo") {
      return insurances;
    }

    if (currentPage.startsWith("client_")) {
      const clientId = parseInt(currentPage.replace("client_", ""));
      return insurances.filter(
        (insurance) => insurance?.entity_type === "Client" && insurance?.entity_obj?.id === clientId
      );
    }

    if (currentPage.startsWith("defendant_")) {
      const defendantId = parseInt(currentPage.replace("defendant_", ""));
      return insurances.filter(
        (insurance) =>
          insurance?.entity_type === "Defendant" && insurance?.entity_obj?.id === defendantId
      );
    }

    if (currentPage.startsWith("other_")) {
      const otherId = parseInt(currentPage.replace("other_", ""));
      return insurances.filter(
        (insurance) =>
          insurance?.entity_type === "OtherParty" && insurance?.entity_obj?.id === otherId
      );
    }

    return insurances;
  }, [insurances, currentPage]);

  // Helper to check if entity has insurances
  const hasInsurancesForEntity = useCallback(
    (entityName, entityId) => {
      if (entityName === "Client") {
        return insurances?.some(
          (insurance) =>
            insurance?.entity_type === "Client" && insurance?.entity_obj?.id === entityId
        );
      }
      return insurances?.some(
        (insurance) =>
          insurance?.entity_type === entityName && insurance?.entity_obj?.id === entityId
      );
    },
    [insurances]
  );

  const hasAnyInsurances = insurances?.length > 0;
  // Get unique entities from insurance data
  const entities = useMemo(() => {
    const clients = new Map();
    const defendants = new Map();
    const otherParties = new Map();
    const witness = new Map();

    insurances?.map((insurance) => {
      if (insurance?.entity_type === "Client") {
        // const entity = insurance?.entity_obj;

        // const name = formatInfo(entity);

        clients.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.insurance_type?.name,
        });
      }
      if (insurance?.entity_type === "Defendant") {
        // const entity = insurance?.entity_obj;

        // const name =
        //   entity?.defendantType?.id === 1 ? formatInfo(entity) : entity?.entity_name || "";

        defendants.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.insurance_type?.name,
        });
      }

      if (insurance?.entity_type === "Witness") {
        // const entity = insurance?.entity_obj;

        // const name = formatInfo2(entity);

        witness.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.counsel_type?.name,
        });
      }

      // Add to otherParties map if entity_type is "Other Party"
      if (insurance?.entity_type === "OtherParty") {
        // const entity = insurance?.entity_obj;

        // const name = formatInfo2(entity);

        otherParties.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.insurance_type?.name,
        });
      }
    });
    return {
      clients: Array.from(clients.values()),
      defendants: Array.from(defendants.values()),
      otherParties: Array.from(otherParties.values()),
    };
  }, [insurances]);

  // Generate main tabs - each client, defendant, and party gets their own tab
  const mainTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("all"),
      leftHand: false,
    });
    // Add individual tab for each client (from for_client field)
    entities.clients?.forEach((client) => {
      if (hasInsurancesForEntity("Client", client.id)) {
        tabs.push({
          id: `client_${client.id}`,
          label: `${client.name}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`client_${client.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-client m-r-5" />,
        });
      }
    });

    // Add individual tab for each defendant (using record_id)
    entities.defendants?.forEach((defendant) => {
      if (hasInsurancesForEntity("Defendant", defendant.id)) {
        tabs.push({
          id: `defendant_${defendant.id}`,
          label: `${defendant.name}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`defendant_${defendant.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-defendants m-r-5" />,
        });
      }
    });

    entities.witness?.forEach((witness) => {
      if (hasInsurancesForEntity("Witness", witness.id)) {
        tabs.push({
          id: `witness_${witness.id}`,
          label: `${witness.name}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`witness_${witness.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-witnesses m-r-5" />,
        });
      }
    });

    // Add individual tab for each other party (using record_id)
    entities.otherParties?.forEach((party) => {
      if (hasInsurancesForEntity("OtherParty", party.id)) {
        tabs.push({
          id: `other_${party.id}`,
          label: `${party.name}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`other_${party.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-parties m-r-5" />,
        });
      }
    });

    return tabs;
  }, [handlePageChange, entities, hasInsurancesForEntity, hasAnyInsurances]);

  // Generate view tabs
  const viewTabs = useMemo(() => {
    const tabs = [];

    if (hasAnyInsurances && currentPage !== "photo") {
      tabs.push(
        {
          id: "summary",
          label: "Summary",
          className:
            activeViewType === "summary"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "summary" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => {
            if (isMediaPage) handlePageChange("all");
            setViewType("summary");
          },
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center text-gold"
            >
              <img
                src={DatesIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        },
        {
          id: "detailed",
          label: "Detailed",
          className:
            activeViewType === "detailed"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "detailed" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => {
            if (isMediaPage) handlePageChange("all");
            setViewType("detailed");
          },
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center  text-gold"
            >
              <img
                src={DetailIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        }
      );
    }

    return tabs;
  }, [activeViewType, hasAnyInsurances, currentPage, isMediaPage, handlePageChange]);

  // Generate button tabs
  const buttonTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "insurance-add",
      label: "Insurance",
      className: modalShow ? "active tab-trapezium-cycles-corners" : "tab-trapezium-cycles-corners",
      background: modalShow ? "var(--primary) !important" : "var(--primary-60)",
      left: "0px",
      onClick: () => addInsuranceModalShow(),
      leftHand: true,
      span: (
        <span className="fw-bold  ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, [modalShow]);

  // Generate photo tabs
  const photoTabs = useMemo(
    () => [
      createDocsTab(() => handlePageChange("docs")),
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    [handlePageChange]
  );
  const attachmentTabs = usePageAttachmentTabs(11, photoTabs);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="11" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container overflow-hidden position-relative">
            <div className="d-flex flex-column w-100 position-absolute" style={{ zIndex: 2 }}>
              <SmartResponsiveTabsContainer
                isEmpty={!hasAnyInsurances}
                HandlePage={currentPage}
                tabsData={mainTabs}
                viewTab={viewTabs}
                viewTabControlled={true}
                addTab={buttonTabs}
                photoTab={attachmentTabs}
                photoTabControlled={true}
                handlePageChange={handlePageChange}
                viewType={activeViewType}
              />
            </div>
            <div
              className="invisible-scrollbar h-100"
              style={{ overflowX: "hidden", overflowY: "scroll", marginTop: "25px" }}
            >
              {filteredInsurances?.length === 0 && !isMediaPage ? (
                <>
                  <PlaceHolderifNothingAdded
                    text1={"No Insurance added to the Case"}
                    text2={"Click to Add"}
                    pageIcon={pageObject?.page_icon}
                    onClick={() => addInsuranceModalShow()}
                  />
                </>
              ) : (
                <PageContent
                  currentPage={currentPage}
                  filteredInsurances={filteredInsurances}
                  viewType={viewType}
                  editModal={editModal}
                  setEditModal={setEditModal}
                  handleEditModalShow={handleEditModalShow}
                  billData={billData}
                  pageName={pageObject?.name}
                  pageIcon={pageObject?.page_icon}
                />
              )}
              <NotesSectionDashboard pageName={"Insurance"} />
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {modalShow && (
        <InsuranceModal
          insurance={editModal}
          show={modalShow}
          handleInsuranceCreation={handleInsuranceCreation}
          handleClose={handleInsuranceModalClose}
          activeTab={activeTav}
          deleteInsuranceHandler={deleteInsuranceHandler}
          addInsurance={addInsurance}
          billData={billData}
        />
      )}

      {showDeleteModal && (
        <ConfirmDeleteModal
          handleClose={() => setShowDeleteModal(false)}
          handleDeleteSubmission={handleDelete}
        />
      )}
    </>
  );
}

export default NewInsurancePage;
